import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = () => {
    const navigate = useNavigate();

    const handleButtonClick = (path: string) => {
        navigate(path);
    };

    return (
        <Box className="dashboard">
            <Button onClick={() => handleButtonClick('/dashboard/about')}>About</Button>
            <Button onClick={() => handleButtonClick('/dashboard/services')}>Services</Button>
            <Button onClick={() => handleButtonClick('/dashboard/news')}>News</Button>
            <Button onClick={() => handleButtonClick('/dashboard/industries')}>Industries</Button>
        </Box>
    );
};

export default Dashboard;